const Third = () => {
  const values = [
    {
      icon: (
        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
        </svg>
      ),
      title: "Transparência",
      description: "Operamos com clareza em todas as interações, sem promessas vazias."
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      title: "Cliente em Primeiro",
      description: "Entendemos profundamente suas dores para oferecer soluções personalizadas."
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
      title: "Resultados Tangíveis",
      description: "Entregamos soluções que geram ROI mensurável e comprovado."
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      title: "Praticidade",
      description: "Desenvolvemos sistemas que simplificam o dia a dia das empresas."
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      ),
      title: "Parceria",
      description: "Proximidade e dedicação em cada etapa do processo."
    },
    {
      icon: (
        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      ),
      title: "Inovação",
      description: "Na vanguarda das atualizações em IA para manter você à frente."
    },
  ];

  const metrics = [
    { value: "+50", label: "Empresas transformadas" },
    { value: "+3", label: "Anos no mercado" },
    { value: "+25M", label: "Em vendas assistidas por IA" },
    { value: ">90%", label: "Eficiência operacional" },
    { value: "+15", label: "Grandes contas ativas" },
  ];

  return (
    <>
      {/* Manifesto Section */}
      <section id="about" className="relative py-24 lg:py-32 bg-[#f6f6f6]">
        <div className="absolute inset-0 bg-grid opacity-30" />

        <div className="relative z-10 mx-auto max-w-7xl px-6">
          <div className="max-w-3xl mx-auto text-center">
            {/* Badge */}
            <span className="text-sm font-medium text-[#1f2fd6] uppercase tracking-wider">
              Nosso Propósito
            </span>

            {/* Main Quote */}
            <blockquote className="mt-8">
              <p className="text-2xl sm:text-3xl lg:text-4xl font-medium text-[#212223] leading-relaxed">
                "Decodificamos a complexidade dos negócios e aplicamos a inteligência artificial de forma estratégica para gerar
                <span className="gradient-text-blue"> crescimento, eficiência e vantagem competitiva.</span>"
              </p>
            </blockquote>

            {/* Description */}
            <p className="mt-8 text-lg text-[#5a5a5a] max-w-2xl mx-auto">
              Não acreditamos em tecnologia pela tecnologia. Acreditamos em soluções com propósito.
              A IA, para nós, não é uma coleção de algoritmos, mas uma ferramenta para esculpir o futuro.
            </p>
          </div>
        </div>
      </section>

      {/* Metrics Section */}
      <section className="relative py-16 bg-[#0c1aa6]">
        <div className="mx-auto max-w-7xl px-6">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
            {metrics.map((metric, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white">
                  {metric.value}
                </div>
                <div className="mt-2 text-sm sm:text-base text-[#c1d5ed]">
                  {metric.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="relative py-24 lg:py-32 bg-white">
        <div className="absolute inset-0 bg-grid opacity-30" />

        <div className="relative z-10 mx-auto max-w-7xl px-6">
          {/* Section Header */}
          <div className="text-center mb-16">
            <span className="text-sm font-medium text-[#1f2fd6] uppercase tracking-wider">
              Nossos Valores
            </span>
            <h2 className="mt-4 text-3xl sm:text-4xl font-bold text-[#212223]">
              Por que escolher a ArkSpace?
            </h2>
            <p className="mt-4 text-lg text-[#5a5a5a] max-w-2xl mx-auto">
              Nossos valores fundamentais guiam cada solução que entregamos.
            </p>
          </div>

          {/* Values Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {values.map((value, index) => (
              <div
                key={index}
                className="group p-6 lg:p-8 rounded-2xl bg-[#f6f6f6] border border-[#1f2fd6]/10 hover:border-[#1f2fd6]/30 transition-all duration-300 shadow-sm hover:shadow-md"
              >
                {/* Icon */}
                <div className="w-12 h-12 rounded-xl bg-[#1f2fd6]/10 flex items-center justify-center text-[#1f2fd6] mb-4 group-hover:bg-[#1f2fd6]/20 transition-colors">
                  {value.icon}
                </div>

                {/* Title */}
                <h3 className="text-lg font-semibold text-[#212223] mb-2">
                  {value.title}
                </h3>

                {/* Description */}
                <p className="text-[#5a5a5a] text-sm leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default Third;
